module.exports = __webpack_public_path__ + "img/progress_020.43e43aa9.png";